/**
 * Build-Your-PAB wizard steps, as saved in `users.build_pab_step`.
 *
 * Kept out of BuildPABCard.tsx so that file exports only components (mixing
 * the two breaks React Fast Refresh).
 *
 *   1-6   the step the achiever is on (6 = Payment, for users who owe it)
 *   7     finished (TOTAL_BUILD_PAB_STEPS + 1) -- written only once payment
 *         has succeeded, or by users who don't pay when they finish step 5
 */

/**
 * Highest step id in the wizard. Adding the payment step moved the "finished"
 * sentinel from 6 to 7, so migration `bump_build_pab_step_for_payment` remaps
 * anyone parked on the old value -- without it, every already-finished user
 * would read as "sitting on the payment step" and see the draft banner again.
 */
export const TOTAL_BUILD_PAB_STEPS = 6;

/** The wizard's payment step. */
export const BUILD_PAB_PAYMENT_STEP = 6;

/** The board is formed, its advisors are held back, and payment is owed. */
export const isPabPaymentOwed = (workingStatus: string | null | undefined): boolean =>
  workingStatus === "PAB_PENDING_PAYMENT";

/**
 * The wizard step to resume at, or null when there is nothing to resume.
 *
 * Owing payment always resumes at the payment step, whatever step was saved:
 * users who left step 6 unpaid on older builds have "finished" saved, and the
 * board's own status is what says they still owe it. Otherwise a saved step
 * 2-6 is resumed as is; step 1 (only just opened) and "finished" are not drafts.
 */
export const buildPabResumeStep = (
  savedStep: number | null | undefined,
  paymentOwed = false,
): number | null => {
  if (paymentOwed) return BUILD_PAB_PAYMENT_STEP;
  if (!savedStep || savedStep <= 1 || savedStep > TOTAL_BUILD_PAB_STEPS) return null;
  return savedStep;
};
